import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { AssetState } from '@models/Core/Asset';
import { PrimeIcons } from 'primeng/api';
import { Subscription } from 'rxjs';

import {
  VideoClipFormControl,
  VideoProjectFormService,
} from '../../video-project.form';

const SEVERITY_MAP: Record<AssetState, string> = {
  pending: 'secondary',
  generating: 'info',
  error: 'danger',
  ready: 'primary',
};

const ICON_MAP: Record<AssetState, string> = {
  pending: PrimeIcons.STOPWATCH,
  generating: 'pi-spin' + ' ' + PrimeIcons.SPINNER,
  error: PrimeIcons.TIMES_CIRCLE,
  ready: PrimeIcons.PLAY_CIRCLE,
};

const DISABLED_MAP: Record<AssetState, boolean> = {
  pending: true,
  generating: true,
  error: true,
  ready: false,
};

@Component({
  selector: 'app-video-preview-clip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './video-preview-clip.component.html',
  styleUrl: './video-preview-clip.component.scss',
})
export class VideoPreviewClipComponent implements OnInit {
  @Input() clip: FormGroup<VideoClipFormControl>;
  @Input() active: boolean;

  @Output() clipClick = new EventEmitter();

  progress = 0;

  get severity() {
    return SEVERITY_MAP[this.clip.value.asset.state];
  }

  get icon() {
    return ICON_MAP[this.clip.value.asset.state];
  }

  get disabled() {
    return this.active || DISABLED_MAP[this.clip.value.asset.state];
  }

  constructor(
    private readonly destroyRef: DestroyRef,
    private readonly videoProjectFormService: VideoProjectFormService,
  ) {}

  ngOnInit(): void {
    if (!this.clip?.value?.asset) {
      return;
    }
    let subscription: Subscription | undefined;
    this.videoProjectFormService
      .$onActiveResourceChanges()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(active => {
        if (subscription) {
          this.progress = 0;
          subscription.unsubscribe();
        }
        if (!active) {
          return;
        }
        if (active.id === this.clip.value.id) {
          subscription = active.$onProgressChanges.subscribe(progress => {
            this.progress = progress;
          });
        }
      });
  }

  onClick() {
    this.clipClick.emit();
  }
}
